module.exports = __webpack_public_path__ + "img/spinner-circle-clear.ce451f01.svg";